var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { format } from "date-fns";
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { openAsyncWindow } from "./WindowHelpers";
export class PatientConsentUseExistingRecordsViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    get lastAccessedDate() {
        var _a;
        const asOf = (_a = this.patientConsentUIManager.existingRetrievalLastUpdatedAt) !== null && _a !== void 0 ? _a : new Date();
        return format(asOf, "LLL d, yyyy");
    }
    get lastRecordsSummary() {
        return this.patientConsentUIManager.existingRecordsSummary;
    }
    async useExistingRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(false);
        await this.patientConsentUIManager.reuseExistingRecords();
        this.goToNextPage();
    }
    lookForUpdatedRecords() {
        this.patientConsentUIManager.updateUserChoseToUpdateRecords(true);
        this.goToNextPage();
    }
    async showUnifiedRecord(type = "pdf") {
        void openAsyncWindow(async () => {
            var _a, _b, _c, _d;
            const url = type === "raw"
                ? (_b = (await this.patientConsentUIManager.getDownloadRawDocumentsLink((_a = this.patientConsentUIManager.existingRetrieval) !== null && _a !== void 0 ? _a : undefined))) === null || _b === void 0 ? void 0 : _b.downloadLink
                : (_d = (await this.patientConsentUIManager.getDownloadPdfLink((_c = this.patientConsentUIManager.existingRetrieval) !== null && _c !== void 0 ? _c : undefined))) === null || _d === void 0 ? void 0 : _d.downloadLink;
            if (!url) {
                console.warn(`No URL available`);
                return null;
            }
            return url;
        }).catch((e) => {
            console.error("[PatientConsentUseExistingRecords] Failed to open unified record", e);
        });
    }
}
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "lastAccessedDate", null);
__decorate([
    computed
], PatientConsentUseExistingRecordsViewModel.prototype, "lastRecordsSummary", null);
